import { CSSProperties } from "react";

interface FrameBoxProps {
  children: React.ReactNode;
  style?: CSSProperties;
  contentStyle?: CSSProperties
}

export default function FrameBox({children, style, contentStyle }: FrameBoxProps) {
  return (
    <div className="oriental-frame" style={style}>
      <div className="frame-content" style={contentStyle}>
        {children}
      </div>
    </div>
  );
}
